/**
 * Full-page case creator (replaces the prior CaseCreate dialog popup).
 * Mounted at /cases/new.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CaseCreateModal from '../components/case/CaseCreateModal';
import { Button } from '../components/ui/button';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { BACKEND_URL } from '../config/canonical';

const TOKEN_KEY = 'nexus_token';

export default function CaseCreatePage() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [investigators, setInvestigators] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem(TOKEN_KEY);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const headers = { Authorization: `Bearer ${token}` };
        const [c, u] = await Promise.all([
          fetch(`${BACKEND_URL}/api/clients`, { headers }).then(r => r.ok ? r.json() : { clients: [] }).catch(() => ({ clients: [] })),
          fetch(`${BACKEND_URL}/api/users`, { headers }).then(r => r.ok ? r.json() : { users: [] }).catch(() => ({ users: [] })),
        ]);
        if (!alive) return;
        setClients(c.clients || c || []);
        setInvestigators(u.users || u || []);
      } finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, [token]);

  if (loading) {
    return <div className="p-6 text-slate-300"><Loader2 className="inline w-4 h-4 animate-spin mr-2" /> Loading…</div>;
  }

  return (
    <div className="space-y-3" data-testid="case-create-page">
      <div className="flex items-center gap-3">
        <Button onClick={() => navigate('/cases')} variant="outline" className="border-slate-600 !text-slate-200" data-testid="case-create-back">
          <ArrowLeft className="w-4 h-4 mr-1.5" /> Back to Cases
        </Button>
      </div>
      <CaseCreateModal
        asPage
        clients={clients}
        investigators={investigators}
        token={token}
        onSuccess={(data) => {
          if (data?.id) navigate(`/cases/${data.id}`);
          else navigate('/cases');
        }}
      />
    </div>
  );
}
